export default "<h3>Please select trumps:</h3>\n<hand [cards]=\"cards\" (cardChosen)=\"suitChosen($event)\" [active]=\"true\" [compact]=\"false\"></hand>\n"